module.exports = __webpack_public_path__ + "assets/f99d529081cb144180ffec906394c398.mp3";